import { NOVIDADES_VERSION } from '../dashboard/novidades/novidadesData';
import AuthHeroPanel from './AuthHeroPanel';

/* ============================================================================
   Moldura das telas de autenticacao: formulario a esquerda, ilustracao a direita.

   POR QUE ISTO FOI REESCRITO (18/08/2026): o tema claro/escuro NAO funcionava
   aqui, e a causa era estrutural - todas as cores estavam em `style` inline com
   valores literais (`#f7fbff`, `rgba(8,28,70,0.94)`). Estilo inline nao tem como
   reagir a `data-theme` no <html>: ele nao participa de cascata, media query nem
   seletor de atributo. Eu mesmo tinha DOCUMENTADO essa limitacao como se fosse
   decisao; era racionalizacao de um defeito.

   ---------------------------------------------------------------------------
   ESTRUTURA "B - CARTAO ELEVADO" (escolhida em 20/08/2026)

   O problema que ela resolve: a coluna do formulario empilhava TRES BRANCOS a
   menos de 3% um do outro - pagina #f6f7f9, painel #ffffff, cartao #fafbfc. O
   cartao entao nao se lia como cartao, e ainda tinha borda E sombra dentro de um
   painel que ja estava vazio: caixa dentro de caixa.

   Agora os papeis estao invertidos e separados:
     - o painel usa o TOM DO FUNDO (`bg-fundo`), nao branco;
     - o cartao e a superficie pura (`bg-surface`) com sombra de verdade, e passa
       a ser a unica coisa clara da coluna - e para onde o olho vai;
     - o vazio ganha TEXTURA (malha de pontos discreta), em vez de ser um vazio.

   A marca mora DENTRO do cartao, no topo: com o painel tingido, a marca solta no
   meio do nada nao tinha a que se ancorar.

   O QUE CONTINUA FIXO, e por que: o painel da ilustracao segue escuro nos dois
   temas. E uma arte com foguete e brilho azul desenhados sobre azul-marinho;
   clarear o fundo mantendo a arte deixaria o foguete num retangulo branco. Arte
   tem lado certo - preferencia de tema nao muda isso.
   ============================================================================ */

/* Mesma fonte que o rodape e a lateral usam - a versao vive em UM lugar. */
const VERSAO = NOVIDADES_VERSION;

/* O SELO DE AMBIENTE ("HOMOLOGAÇÃO") SAIU em 20/08/2026, a pedido.

   Ele aparecia no rodape sempre que `NODE_ENV` nao era producao. A ideia era
   evitar testar em homologacao achando que era o ambiente real - mas em
   desenvolvimento isso e ruido em toda recarga, e quem sobe a tela sabe onde
   esta. Se um dia fizer falta, o gancho e uma linha:
   `process.env.NODE_ENV === 'production'`, o mesmo que o vite.config usa para
   escolher a URL da API. */

function RodapeConfianca() {
  return (
    <div className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t border-line pt-3 text-[11px] text-faint">
      <span className="inline-flex items-center gap-1.5">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden className="text-primary">
          <path
            d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.35C16.5 21.15 20 16.25 20 11V5L12 2z"
            fill="currentColor"
            opacity="0.2"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Conexão segura SSL/TLS
      </span>

      {VERSAO && <span className="tabular-nums">v{VERSAO}</span>}
    </div>
  );
}

export default function AuthLayout({ children, footer, headerContent, maxFormWidth = 400 }) {
  return (
    /* SEM MOLDURA (10/09/2026, a pedido).

       Havia `p-4 sm:p-6` no fundo mais `rounded-[28px] border shadow-card` no
       bloco de dentro: uma faixa cinza em volta de tudo e um cartao gigante
       desenhado dentro da janela. Numa tela de entrada, que ocupa a janela inteira
       e nao esta "em cima" de nada, essa moldura nao delimita coisa alguma - so
       tira 48px de cada lado da ilustracao e do formulario.

       O cartao do formulario continua com moldura, e ali ela trabalha: e ele que
       precisa se destacar do fundo. */
    <div className="min-h-screen bg-fundo">
      {/* SEM `max-w`: com 1820px de teto, uma janela maior deixava uma faixa do
          fundo cinza aparecendo dos DOIS lados - lida como borda, que e justamente
          o que se pediu para tirar. Tela de entrada ocupa a janela inteira. */}
      <div className="flex min-h-screen w-full overflow-hidden">
        {/* Coluna do formulario. `bg-fundo` e nao `bg-surface`: e o cartao que
            precisa ser a superficie clara aqui. Abaixo de lg a ilustracao sai e
            esta coluna ocupa tudo - num celular a arte roubaria a tela inteira do
            formulario. */}
        <div className="relative flex w-full flex-none items-center justify-center bg-fundo px-6 py-10 sm:px-10 lg:max-w-[620px]">
          {/* TEXTURA DE PONTOS.

              Em `style` porque e uma malha de uma unica ocorrencia - virar classe
              arbitraria do Tailwind daria uma string ilegivel e nenhuma
              reutilizacao. `currentColor` nao serve em background-image, entao a
              cor sai do token de linha, que ja existe nos dois temas.

              `opacity-60` e o ponto de 1px: a malha tem que ser percebida como
              superficie, nao como padrao. Se der para contar os pontos, esta
              forte demais. */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 opacity-60"
            style={{
              backgroundImage: 'radial-gradient(var(--gps-line) 1px, transparent 1px)',
              backgroundSize: '18px 18px',
            }}
          />

          {/* Brilho de canto, por cima da malha: da profundidade ao canto superior
              esquerdo e acompanha o tema pelo token do primary. */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0"
            style={{
              background: 'radial-gradient(circle at 16% 14%, hsl(var(--primary) / 0.10) 0%, transparent 30%)',
            }}
          />

          <div className="relative z-[1] w-full" style={{ maxWidth: maxFormWidth }}>
            {/* O CARTAO: superficie pura, sombra forte, arredondamento maior.
                `animate-subir` sem atraso - ele e o primeiro a assentar, e os
                blocos de dentro vem depois (ver CamposAuth/os formularios). */}
            {/* Sem borda: a sombra ja separa o cartao do fundo, e borda MAIS sombra
                sao dois contornos para o mesmo trabalho. */}
            <div className="animate-subir rounded-3xl bg-surface px-7 py-8 shadow-elevado sm:px-9">
              <div className="mb-6 flex justify-center">
                {/* `h-11` (44px) por escolha do usuario. Registro do que isso
                    custa: a marca e um PNG de 745x287, e 287/44 = 6,52 - fracao
                    quebrada faz o navegador reamostrar e a borda amolecer um
                    pouco. Em 48px a escala seria ~1/6 exato e sairia mais limpa.
                    Fica em 44px porque foi o pedido; se um dia aparecer o vetor da
                    marca, a questao desaparece. */}
                <img src="/images/gps_hub.png" alt="GPShub" className="h-11 w-auto object-contain" />
              </div>

              {headerContent}
              {children}
              {footer}

              <RodapeConfianca />
            </div>
          </div>
        </div>

        {/* Ilustracao: escondida abaixo de lg. */}
        <div className="hidden min-w-0 flex-1 lg:block">
          <AuthHeroPanel />
        </div>
      </div>
    </div>
  );
}
